import React, { Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';

// Components

import AgentPromotion from '../../components/individualPortal/AgentPromotion';
import CommunicationPreferencesContainer from './CommunicationPreferencesContainer';
import DashboardContainer from './dashboard/DashboardContainer';
import ApplicationsContainer from './applications/ApplicationsContainer';
import DelegationContainer from '../delegation/DelegationContainer';
import EligibilityResultsContainer from './eligibilityResults/EligibilityResultsContainer';
import MultiHouseholdDetails from './multiHouseholdDetails';
import SideNavContainer from './navigation/SideNavContainer';
import WelcomeUser from '../../components/individualPortal/dashboard/WelcomeUser';
import Announcements from '../../components/individualPortal/dashboard/announcements';
import TicketContainer from './ticket/TicketContainer';
import TicketSummaryContainer from './ticket/TicketSummaryContainer';
import CustomGroupingContainer from '../../modules/custom-grouping';
import MyEnrollmentHistoryContainer from './myEnrollment/MyEnrollmentHistoryContainer';
import TobaccoExemptContainer from '../../modules/tobacco-exempt';

import PrivateRoute from '../../components/navigation/PrivateRoute';
import RouteRenderEnvironment from '../../routes/RouteRenderEnvironment';

// ActionCreators

import { getTickets } from '../../actions/individualPortal/ticket/ticketActionCreators';
import { showModal } from '../../actions/common/actionCreators';
import { verifyAccessCode } from '../../actions/individualPortal/dashboard/dashboardActionCreators';
import { fetchUnreadNotificationCount } from '../../actions/individualPortal/secureInbox/secureInboxActionCreators';

// Utils

import { extractUserName } from '../../utils/miscellaneous/extractUserName';

// Constants

import { configs } from '../../constants/configs/configs';

const IndividualPortalContainer = (props) => {
    const {
        match: {
            path
        },
        environment
    } = props;

    const {
        routes: {
            APPLICATIONS,
            COMMUNICATION_PREFERENCES,
            DELEGATION_CONSUMER,
            ELIGIBILITY_RESULTS,
            MULTI_HOUSEHOLD_DETAILS,
            TICKET_CONSUMER,
            TICKET_CONSUMER_DETAIL,
            CUSTOM_GROUPING,
            MY_ENROLLMENT_HISTORY,
            TOBACCO_EXEMPT
        }
    } = configs;

    const userName = extractUserName(environment);
    const isDelegationPage = props.location.pathname === DELEGATION_CONSUMER;
    const isTicketEnabled = environment.ticketEnabled;

    sessionStorage.setItem('PLAN_SUMMARY_USER_NAME', userName);

    return (
        <main className="usa-layout-docs usa-section gi-main-section" id="individual-portal">

            <div className="grid-container gi-grid-container">
                <div className={`grid-row grid-gap gi-wrapper ${isDelegationPage && 'gi-wrapper-delegations'}`}>

                    <Fragment>
                        <div className="grid-col-12">
                            <WelcomeUser userName={userName} />
                        </div>
                        <div className="grid-col-12">
                            <Announcements />
                        </div>
                        <aside className="desktop:grid-col-3" id="side-nav">
                            <SideNavContainer { ...props  }/>
                        </aside>
                        <div className="desktop:grid-col-9" id="main-content">
                            <Switch>
                                <Route path={path} exact component={DashboardContainer} />
                                <Route path={TOBACCO_EXEMPT} exact render={(props) => <RouteRenderEnvironment component={TobaccoExemptContainer} {...props}/>}/>
                                <Route path={APPLICATIONS} exact render={(props) => <RouteRenderEnvironment component={ApplicationsContainer} {...props} />} />
                                <Route path={COMMUNICATION_PREFERENCES} exact render={(props) => <RouteRenderEnvironment component={CommunicationPreferencesContainer} {...props} />} />
                                <Route path={DELEGATION_CONSUMER} exact render={(props) => <RouteRenderEnvironment component={DelegationContainer} {...props} />} />
                                <Route path={ELIGIBILITY_RESULTS} exact render={(props) => <RouteRenderEnvironment component={EligibilityResultsContainer} {...props} />} />
                                <Route path={MULTI_HOUSEHOLD_DETAILS} exact component={MultiHouseholdDetails} />
                                <Route path={CUSTOM_GROUPING} exact component={CustomGroupingContainer} />
                                <Route path={MY_ENROLLMENT_HISTORY} exact component={MyEnrollmentHistoryContainer} />
                                <Route path={CUSTOM_GROUPING} exact render={(props) => <RouteRenderEnvironment component={CustomGroupingContainer} {...props} />} />
                                <PrivateRoute path={TICKET_CONSUMER} isAllowed={isTicketEnabled} exact={true} component={TicketContainer} />
                                <PrivateRoute path={TICKET_CONSUMER_DETAIL} isAllowed={isTicketEnabled} exact={true} component={TicketSummaryContainer} />
                            </Switch>
                        </div>
                    </Fragment>

                </div>
            </div>

            <AgentPromotion />
        </main>
    );
};

const mapStateToProps = state => ({
    environment: state.common.environment
});
const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        verifyAccessCode,
        showModal,
        getTickets,
        fetchUnreadNotificationCount
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(IndividualPortalContainer);
